<div class="dashboard-layout">

  <aside class="sidebar">

    <h2>Manager</h2>

    <nav>

      <a routerLink="/dashboard">
        Dashboard
      </a>

      <a routerLink="/cadastro-usuarios">
        Usuários
      </a>

      <a href="#">
        Configurações
      </a>

    </nav>

    <button (click)="logout()">
      Sair
    </button>

  </aside>

  <main class="content">

    <header>

      <h1>
        Bem-vindo, {{ userName }}
      </h1>

    </header>

    <section class="cards">

      <div class="card">
        <h3>Total de usuários</h3>
        <span>120</span>
      </div>

      <div class="card">
        <h3>Pedidos</h3>
        <span>57</span>
      </div>

      <div class="card">
        <h3>Faturamento</h3>
        <span>R$ 12.500</span>
      </div>

    </section>

  </main>

</div>